import * as React from "react";
import { debounce, omit, noop } from "lodash";
import { LiveRegion } from "@root/shared";
import { InputProps, InputState, Input } from "./input";
const css = require("./input.scss");
import { t } from "@root/lib/i18n";

export interface SearchInputProps extends InputProps {
  resultsCount?: number;
  setRef?: React.RefObject<Input<any>>;
}

export interface SearchInputState extends InputState {
  screenReaderText: string;
}

/**
 * @deprecated
 * Use SearchInput or BorderlessSearchInput, typically in the header area of the Card
 * that contains the content you’re searching.
 */
export class SearchInput extends React.Component<SearchInputProps, SearchInputState> {
  public static displayName = "SearchInput";
  public static defaultProps = {
    resultsCount: 0,
    setRef: noop
  };

  public state = {
    screenReaderText: ""
  };

  public UNSAFE_componentWillReceiveProps(nextProps: SearchInputProps) {
    const { resultsCount: resultsNext } = nextProps;
    const { resultsCount } = this.props;
    if (resultsNext && resultsNext !== resultsCount) {
      this.setState({ screenReaderText: "" });
      this.updateScreenReaderText(resultsNext);
    }
  }

  public componentWillUnmount() {
    this.updateScreenReaderText.cancel();
  }

  private updateScreenReaderText = debounce((results: number): void => {
    const screenReaderText = !!results
      ? t("common:input.search.resultsAnnouncement", { count: results })
      : t("common:input.search.noResultsAnnouncement");
    this.setState({ screenReaderText });
  }, 2000);

  public render() {
    const { setRef } = this.props;
    const { screenReaderText } = this.state;
    const passthrough = omit(this.props, "setRef", "resultsCount");

    return (
      <>
        <Input role="search" data-test-id="search-text-box" ref={setRef as any} {...passthrough} />
        <LiveRegion active={screenReaderText.length !== 0} role="alert" className={css["searchbar-sr-text"]}>
          {screenReaderText}
        </LiveRegion>
      </>
    );
  }
}
